
// 设置用户 token
export function setUserToken ( userToken ) {
    sessionStorage.setItem("token", userToken) ;
}
// 获取用户 token
export function getUserToken () {
    return  sessionStorage.getItem("token");
}




